import { useRequest } from 'ahooks'

import { certificateFromData } from '@/components/NewEditForm/UILibrary/HYBElement/BlockLevel/BlockLevelForm/utils'
import { http } from '@/utils'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'
// 教育经历 添加/编辑
export const saveEducation = (data: any): any => http.post('/hrm/education', data)
// 教育经历 批量删除
export const deleteHrmEducation = (data: any) => http.delete('/hrm/education', { data })
export default ({ value, onConfirm }: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  // 教育经历 添加/编辑
  const { run: runSaveEducation, loading: saveEducationLoading } = useRequest(saveEducation, {
    manual: true,
    onSuccess: (result: any) => {
      const { code } = result
      if (code === 2000) {
        onCancel()
        onConfirm()
      }
    },
    onError: ({ message }) => {
      console.log('error', message)
    }
  })

  // 教育经历 批量删除
  const { run: runDeleteHrmEducation, loading: deleteHrmEducationLoading } = useRequest(
    deleteHrmEducation,
    {
      manual: true,
      onSuccess: (result: any) => {
        const { code } = result
        if (code === 2000) {
          onCancel()
          onConfirm()
        }
      },
      onError: ({ message }) => {
        console.log('error', message)
      }
    }
  )
  const add = () => {
    onOpen({ status: 'Add', editItem: {} })
  }

  const edit = (index: number) => {
    const fieldValues = value?.[index] || {}
    const attachment = certificateFromData(fieldValues?.attachments || [])
    onOpen({ status: 'Edit', editItem: { ...fieldValues, attachment } })
  }

  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runSaveEducation,
    runDeleteHrmEducation,
    deleteHrmEducationLoading,
    saveEducationLoading
  }
}
